import {createAction} from "typesafe-actions";
import {HtmlSignature} from "../types/htmlSignatures";
import {Paginated} from "../utils/commons";
import {DataSignature} from "../types/dataSignatures";
import {AesSignature, PdfSignature} from "../types/pdfSignatures";
import {Timestamp} from "../types/timestamps";

export const gotHtmlSignatures = createAction("SIGNATURE/got html signatures", (signatures: Paginated<HtmlSignature>) => (signatures))();
export const gotHTMLJson = createAction("SIGNATURE/got html json", (json?: object) => json)();

export const gotDataSignatures = createAction("SIGNATURE/got data signatures", (signatures: Paginated<DataSignature>) => (signatures))();
export const gotDataJson = createAction("SIGNATURE/got data json", (json?: object) => json)();

export const gotPdfSignatures = createAction("SIGNATURE/got pdf signatures", (signatures: Paginated<PdfSignature>) => (signatures))();
export const gotPdfJson = createAction("SIGNATURE/got pdf json", (json?: object) => json)();

export const gotAesSignatures = createAction("SIGNATURE/got aes signatures", (signatures: Paginated<AesSignature>) => (signatures))();
export const gotAesJson = createAction("SIGNATURE/got aes json", (json?: object) => json)();

export const gotTimestamps = createAction("SIGNATURE/got timestamps", (timestamps: Paginated<Timestamp>) => (timestamps))();
